import React from 'react';
import { I18n } from 'js/components/common/I18n';
import { CheckboxShallow } from 'js/components/common/Fields/Checkbox';
import { Toggle } from 'js/components/common/Fields/Toggle';
import { usePortletTranslations } from 'js/components/system/Portlet';
import InfoList from 'js/components/common/InfoList';
import { useEventHandlers, useListProps } from './hooks';
import style from './index.scss';

export const TogglesList = ({ t, type, items, isAllChecked, showAll, onChange, onChangeAll, showTitle = true }) =>
    <>
        {showTitle && <p className={style.title}>{t(`${type}.section`)}</p>}
        <InfoList className={style.list}>
            {showAll && (
                <Toggle
                    label={<I18n {...{ t, tKey: `${type}.all` }} />}
                    checked={isAllChecked}
                    onChange={onChangeAll}
                    className={style.toggle}
                />
            )}
            {items.map(({ channel, preference }, index) =>
                <Toggle
                    key={`${type}-${index}`}
                    label={<I18n {...{ t, tKey: `${type}.${channel}` }} />}
                    checked={preference}
                    data-index={index}
                    onChange={onChange}
                    className={style.toggle}
                />
            )}
        </InfoList>
    </>;

export default ({ withToggles = true, type: listType }) => {
    const {
        items,
        isAllChecked,
        showAll
    } = useListProps(listType);
    const {
        onChange,
        onChangeAll
    } = useEventHandlers(listType);
    const t = usePortletTranslations();

    if (!items.length) {
        return null;
    }

    if (withToggles) {
        return <TogglesList {...{
            type: listType,
            items,
            isAllChecked,
            showAll,
            t,
            onChange,
            onChangeAll
        }} />;
    }

    return items.map(({ type, preference }, index) =>
        <CheckboxShallow
            key={`${type}-${index}`}
            className={style.row}
            data-index={index}
            checked={preference}
            onChange={onChange}
            label={<I18n {...{ t, tKey: `${listType}.${type}` }} />}
            wrapText={true}
        />
    );
};
